import { render, staticRenderFns } from "./Active.vue?vue&type=template&id=4cbc0a95&scoped=true&"
import script from "./Active.vue?vue&type=script&lang=ts&"
export * from "./Active.vue?vue&type=script&lang=ts&"
import style0 from "./Active.vue?vue&type=style&index=0&id=4cbc0a95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbc0a95",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VPagination,VSkeletonLoader})
